import React from 'react';
import * as styled from './styled/Button.styled';

export const Button: React.FC<{
    disabled?: boolean;
    onClick: React.ReactEventHandler;
    className?: string;
    variant?: 'contained' | 'outlined';
}> = ({ children, onClick, disabled = false, className, variant = 'contained' }) => {
    return (
        <styled.Button
            disabled={disabled}
            variant={variant}
            className={className}
            onClick={onClick}
        >
            {children}
        </styled.Button>
    );
};
